// ==========================  Blog Search Filter start =========================== //

function filterApply(value, container) {
  const searchValue = value.toLowerCase();
  const faqBlocks = container.querySelectorAll(".block__faq_list_block");

  faqBlocks.forEach((faqBlock) => {
    let hasMatch = false;
    const filterBoxes = faqBlock.querySelectorAll(".filter_box");
    filterBoxes.forEach((box) => {
      const questionTitle = box.querySelector(".block__accordion_title");
      if (!questionTitle) return;
      const dataTitle = questionTitle.getAttribute("data-post-title").toLowerCase();
      if (dataTitle.includes(searchValue)) {
        box.classList.add("faq_active");
        hasMatch = true;
      } else {
        box.classList.remove("faq_active");
      }
    });
    if (hasMatch) {
      faqBlock.style.display = "block";
    } else {
      faqBlock.style.display = "none";
    }
  });
}




document.addEventListener("DOMContentLoaded", function () {

    const blockFilter = document.querySelector('[id^="filter-"]');
  if (blockFilter) {
    blockFilter.addEventListener("keyup", function () {
      filterApply(this.value, this.closest(".page-width"));
    });
  }
// FAQ Toggle
  const container = document.querySelector(".block__slider_main_containar");
  if (!container) return;

  const firstSlide = container.querySelector(".block__slide");
  const firstPanel = firstSlide?.querySelector(".block__panel");

  if (firstSlide && firstPanel) {
    firstSlide.classList.add("block__change_icon");
    firstSlide.querySelector(".block__tabs_title").setAttribute("aria-expanded", "true");
    firstPanel.style.height = firstPanel.scrollHeight + "px";
  }

  document.addEventListener("click", function (event) {
    const tabTitle = event.target.closest(".block__tabs_title");
    if (tabTitle) {
      const slide = tabTitle.closest(".block__slide");
      const panel = slide.querySelector(".block__panel");

      if (slide.classList.contains("block__change_icon")) {
        slide.classList.remove("block__change_icon");
        slide.querySelector(".block__tabs_title").setAttribute("aria-expanded", "false");
        panel.style.height = "0px";
      } else {
        const allSlides = container.querySelectorAll(".block__slide");
        const allPanels = container.querySelectorAll(".block__panel");

        allSlides.forEach(s => s.classList.remove("block__change_icon"));
        allPanels.forEach(p => p.style.height = "0px");

        slide.classList.add("block__change_icon");
        slide.querySelector(".block__tabs_title").setAttribute("aria-expanded", "true");
        panel.style.height = panel.scrollHeight + "px";
      }
    }
  });

 const headings = document.querySelectorAll(".block__js_faq_heading");
  const blocks = Array.from(document.querySelectorAll(".block__faq_list_block"));
  const headerOffset = document.querySelector(".header")?.offsetHeight || 0;

  let scrollLock = false;
  let lastId = "";

  function isMobile() {
    return window.innerWidth <= 991;
  }

  document.addEventListener("click", function (event) {
    const clicked = event.target.closest(".block__js_faq_heading");
    if (!clicked) return;

    const dataId = clicked.getAttribute("data_id");
    const target = document.getElementById(dataId);
    if (!target) return;
    scrollLock = true;
    setTimeout(() => scrollLock = false, 1000);

    const scrollTop = target.offsetTop - 150;
    window.scrollTo({ top: scrollTop, behavior: "smooth" });
    headings.forEach(h => h.classList.remove("active"));
    clicked.classList.add("active");
  });

  window.addEventListener("scroll", function () {
    if (scrollLock || isMobile()) return;

    const scrollTop = window.scrollY + headerOffset + 200;

    let currentId = null;
    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      if (block.offsetTop <= scrollTop) {
        currentId = block.id;
      }
    }

    if (currentId && currentId !== lastId) {
      lastId = currentId;

      headings.forEach(h => {
        const dataId = h.getAttribute("data_id");
        h.classList.toggle("active", dataId === currentId);
      });
    }
  });


// Mobile Dropdown Toggle
  const trigger = document.querySelector(".block__mobile_faq_type_dropdown_block");
  const dropdown = trigger?.querySelector("ul");
  const head = trigger?.querySelector("p");
  const items = dropdown?.querySelectorAll("li");
  const sections = document.querySelectorAll(".block__faq_list_block");

  if (!trigger || !dropdown || !head || !items?.length) return;
  let saved = localStorage.getItem("faq_selected_option") || items[0].textContent.trim();
  head.textContent = saved;
  items.forEach(li => li.classList.toggle("active", li.textContent.trim() === saved));

  document.addEventListener("click", e => {
    if (e.target.closest(".block__mobile_faq_type_dropdown_block")) {
      dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
      trigger.classList.toggle("block__show_dropdown");
    }

    const item = e.target.closest("li");
    if (item && dropdown.contains(item)) {
      const text = item.textContent.trim();
      head.textContent = text;
      localStorage.setItem("faq_selected_option", text);
      items.forEach(li => li.classList.remove("active"));
      item.classList.add("active");
      dropdown.style.display = "none";
      trigger.classList.remove("block__show_dropdown");
    }
  });

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY + (document.querySelector(".header")?.offsetHeight || 0) + 150;
    for (const section of sections) {
      if (section.offsetTop <= scrollTop) {
        const id = section.id;
        items.forEach(li => {
          const match = li.getAttribute("data_id") === id;
          li.classList.toggle("active", match);
          if (match) {
            const text = li.textContent.trim();
            head.textContent = text;
            localStorage.setItem("faq_selected_option", text);
          }
        });
      }
    }
  });


});



